export const countryConfigRO = {
  home: {
    skeleton: {
      banner: true,
      bubbles: true,
      featuredProducts: true,
      services: true,
      starredProductLists: 3,
      starredCards1: false,
      starredCards2: true,
      posts: false
    }
  },
  'landing-courier': {
    bikeCollection: 'pentru-biciclete-si-trotinete',
    carCollection: 'pentru-soferi'
  }
};
